import { makePaymentModalSelectElem, makePaymentModalUnitSelectElem, makePaymentModalUnitsUsersSelectElem, makePaymentModalUnitsSelectElem } from './constants'
import { paymentModalLoadingHide, paymentModalLoadingShow } from '../loading'
import paymentModalErrors from './errors'
import { paymentModalBalance, paymentModalShowAttorneyBalance } from './balance'
import paymentModalIframeDisplay from './display'
import { isMultipleLedgers } from '../load';

export function paymentModalSuccess (data, _textStatus, _jqXHR, selectedRowValue) {
  paymentModalIframeDisplay(false)
  makePaymentModalUnitsUsersSelectElem.empty();

  $.each(data, function (_indx, payment) {
    const paymentWithBalances = isMultipleLedgers(payment);
    let accountName = payment.unit_name;

    if (window.unitsPaymentData && window.unitsPaymentData.length > 1) {
      makePaymentModalUnitSelectElem.removeClass('hide');
      const payment = data[0];
      const selectOptions = window.unitsPaymentData.map(unit => ({ id: unit.id, text: `${unit.id} - ${unit.street_1}`}));

      makePaymentModalUnitsSelectElem.select2({ data: selectOptions, width: '100%' });
      makePaymentModalUnitsSelectElem.val(payment.unit_id).trigger('change');
    }

    if (paymentWithBalances) {
      generateUnitsUsersSelect(payment.unit_name, payment.units_user_uuid, payment.accounts);
      if (selectedRowValue) {
        makePaymentModalUnitsUsersSelectElem.val(selectedRowValue).trigger('change');
      }
    } else {
      const singleLedgerWithBalance = payment.accounts !== undefined && payment.accounts.filter(account => account.balance !== 0).length === 1;
      const newPaymentFormat = singleLedgerWithBalance ? {...payment, ...payment.accounts.find(account => account.balance !== 0)} : payment;
      const optionDisabled = paymentModalShowAttorneyBalance(newPaymentFormat) ? 'disabled' : false;

      if (newPaymentFormat.account_number) {
        accountName += ` (${newPaymentFormat.account_number})`
      }

      makePaymentModalUnitsUsersSelectElem.append($('<option></option>').attr('value', newPaymentFormat.units_user_uuid).attr('disabled', optionDisabled).text(accountName))
    }
  })

  if (window.unitsPaymentData && window.unitsPaymentData.length > 1) {
    makePaymentModalUnitsSelectElem.off('change').on('change', function() {
      const currentValue = $(this).val();
      if (currentValue && currentValue !== data[0].unit_id.toString()) {
        $('#unitsPaymentDropdown').val(currentValue).trigger('change');
        paymentModalLoadingShow();
      }
    });
  }

  makePaymentModalUnitsUsersSelectElem.on('change', function () {
    const selectedValue = $(this).val() || $(this).find('option').val();
    if (!selectedValue) {
      return;
    }
    let payment = null;
    const paymentWithBalances = selectedValue.split('|').length > 1;

    if (paymentWithBalances) {
      const [unitUserUuid, accountNumber] = selectedValue.split('|');
      const dataSource = window.unitsPaymentData && window.unitsPaymentData.length > 1 ? window.paymentData : data;
      const matchPayment = dataSource.filter(function (p) { return unitUserUuid.indexOf(p.units_user_uuid) > -1 })[0];

      if (matchPayment && Object.keys(matchPayment).length > 0) {
        const matchAccount = matchPayment.accounts.find(account => account.account_number === accountNumber);
        payment = {...matchPayment, ...matchAccount};

      }
    } else {
      payment = data.filter(p => selectedValue.indexOf(p.units_user_uuid) > -1)[0]
      const singleLedgerWithBalance = payment.accounts !== undefined && payment.accounts.filter(account => account.balance !== 0).length === 1;

      payment = singleLedgerWithBalance ? {...payment, ...payment.accounts.find(account => account.balance !== 0)} : payment;
    }

    toggleSelectChange(payment)
  });

  if (selectedRowValue && !window.unitsPaymentData) {
    makePaymentModalUnitsUsersSelectElem.val(selectedRowValue).trigger('change');
  }

  if (data.length !== 0) {
    makePaymentModalSelectElem.removeClass('hide')
  } else {
    makePaymentModalSelectElem.addClass('hide')
  }

  const initialPayment = getInitialPayment(data, selectedRowValue);
  toggleSelectChange(initialPayment);
  paymentModalLoadingHide()
}

export function paymentModalFailure (_jqXHR, _textStatus, _errorThrown) {
  const errorMessages = ['Unable to fetch balance at this time. Please try again later.']

  paymentModalErrors(errorMessages)
  paymentModalLoadingHide()
}

function toggleSelectChange (payment = []) {
  paymentModalErrors (payment.accounting_errors, payment.payment_errors)
  paymentModalBalance(payment)
}

function generateUnitsUsersSelect(accountName, unitsUserUuid, accounts) {
  accounts.filter(account => account.balance !== 0).map(account => {
    const name = `${accountName} (${account.account_number} | ${account.account_name})`;
    const optionDisabled = paymentModalShowAttorneyBalance(account) ? 'disabled' : false;

    makePaymentModalUnitsUsersSelectElem.append($('<option></option>').attr('value', `${unitsUserUuid}|${account.account_number}`).attr('disabled', optionDisabled).text(name))
  });
}

function getInitialPayment(data, selectedValue) {
  const paymentWithBalances = selectedValue && selectedValue.split('|').length > 1;

  if (paymentWithBalances) {
    const [unitUserUuid, accountNumber] = selectedValue.split('|');
    const matchPayment = data.filter(payment => unitUserUuid.indexOf(payment.units_user_uuid) > -1 )[0];

    if (matchPayment && Object.keys(matchPayment).length > 0) {
      const matchAccount = matchPayment.accounts.find(account => account.account_number === accountNumber);

      return {...matchPayment, ...matchAccount};
    }
  }

  if (selectedValue) {
    return data.filter(payment => selectedValue.indexOf(payment.units_user_uuid) > -1)[0];
  }

  return data[0].accounts !== undefined ? {...data[0], ...data[0].accounts.find(account => account.balance !== 0) } : data[0];
}
